import { getStageMode } from '../helpers/getStageMode';

const isStageMode = getStageMode();
export const ENV = {
	SEO_URL: process.env.SEO_URL ?? 'https://liftapp.ai',
	LIFT_WEB_APP_URL: `${process.env.SEO_URL}/editor`,
	OLD_URL: process.env.OLD_URL,
	API_URL: isStageMode
		? 'https://stage-api-subscriptions.liftstory.com'
		: process.env.API_URL,
	API_LIFT_STORY_URL: isStageMode
		? 'https://stage-api.liftstory.com'
		: process.env.API_LIFT_STORY_URL,
	AMPLITUDE_ID: process.env.AMPLITUDE_ID,
	FB_PIXEL_ID: process.env.FB_PIXEL_ID ?? '',
	GTAG_ID: process.env.GTAG_ID,
	GTM_ID: process.env.GTM_ID,
	MS_CLARITY: process.env.MS_CLARITY,
	PROJECT_TYPE: process.env.PROJECT_TYPE,
	LIFT_BIO_EDITOR_URL: process.env.LIFT_BIO_EDITOR_URL,
} as const;
